export const EMAIL_TYPE = 'Email';
export const SMS_TYPE = 'sms';
export const INTERNAL_TYPE = 'internal';
